import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const archivedWorkItemsJswCompanyRoute: InvariantJiraRoute = {
	name: 'software-archived-work-items-classic',
	path: '/jira/software/c/projects/:projectKey/archived-work-items',
	exact: true,
};
